// @flow

import {modalClosed, modalSet} from "../reducers/filterReducer";

export const changeModal = (id: ?number) => {
	return id
		? modalSet(id)
		: modalClosed();
};
